import React, { useState } from "react";
import { useAuth } from "../../Contexts/AuthContext/useAuth.context";
import { useNavigate } from "react-router-dom";

import './Style/Auth.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { AuthenticateUser } from "../../Services/User/AuthenticateUser.service";


const Auth: React.FC = () => {
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    
    const navigate = useNavigate();

    const { setPrevUserCredentials } = useAuth();

    const handleLogin = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsLoading(true);
        if(!email || !password){
            setError('E-mail ou senha incorreto.');
            return;
        }
        const authResult = await AuthenticateUser(email, password);
        if(authResult){
            setPrevUserCredentials({email, password});
        }
        setIsLoading(false);
        navigate('/automations');
    };

    return (
        <form className="form" id="authenticate"> 
            <header className="form-header">
                <div className="header-logo">
                    <img className="app-logo" src="logo-macrolub.png" alt="Logo da empresa Macrolub" />
                </div>
                <div className="header-title">
                    <h2>Login</h2>
                    <small>Digite seu e-mail e senha para acessar.</small>
                </div>
            </header>
            
            <fieldset className="form-group">
                <label className="form-label">
                    <p className="input-label">E-mail</p>
                    <input
                        className="form-input"
                        type="email"
                        placeholder="example@macrolub.com.br"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </label>
                <label className="form-label">
                    <p className="input-label">
                        Senha
                    </p>
                    <input
                        className="form-input"
                        type="password"
                        placeholder="************"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </label>
            </fieldset>
            <button className="button success" onClick={handleLogin}>
                {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                {!isLoading && <p>Entrar</p>}
            </button>
            {error && <p>{error}</p>}
        </form>
    )
}

export default Auth;